import React from 'react';
import PropTypes from 'prop-types';

import Button from '@marvelapp/marvel-ui/button';

export default function HeaderButton({ url, title }) {
  return (
    <a href={url} target="_blank">
      <Button background="white" color="slate" shape="rounded">
        {title}
      </Button>
    </a>
  );
}

HeaderButton.propTypes = {
  isLight: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/DevHeader/HeaderButton/index.js